import request from "@/lib/api/handler";
import { toast } from "sonner";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";

export const useResetUserPassword = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (userId: string) => {
      const token = await getAccessTokenSilently();

      await request({
        method: "POST",
        path: `/api/admin/user/${userId}/reset-password`,
        token,
      });
    },
    onSettled: (_, error) => {
      if (!error) {
        toast.success("Password reset email sent!");
      } else {
        toast.error("Failed to send password reset email, please try again");
      }
    },
  });

  return {
    resetUserPassword: mutate,
    isResettingUserPassword: isPending,
    resetUserPasswordError: error,
  };
};
